'use strict';

var themeNameLight = 'light';
var themeNameDefault = themeNameLight;

exports.themeNameDefault = themeNameDefault;
exports.themeNameLight = themeNameLight;
